import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '../../../core/Icon';
import XPathDialog from '../../../lab/XPathDialog';
/**
 * @extends {React.Component<import('../types').FormInputXPathProps>}
 */

var XPath =
/*#__PURE__*/
function (_React$Component) {
  _inherits(XPath, _React$Component);

  function XPath() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, XPath);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(XPath)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.openXPathEditor = function () {
      return _this.setState({
        open: true
      });
    };

    _this.closeXPathEditor = function () {
      return _this.setState({
        open: false
      });
    };

    _this.onChange = function (value) {
      // @ts-ignore
      _this.props.onChange({
        target: {
          value: value
        }
      });
    };

    return _this;
  }

  _createClass(XPath, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          isCondition = _this$props.isCondition,
          buttonProps = _this$props.buttonProps,
          rest = _objectWithoutProperties(_this$props, ["workspace", "path", "isCondition", "buttonProps"]);

      return React.createElement(React.Fragment, null, React.createElement(TextField, Object.assign({}, rest, {
        InputProps: {
          endAdornment: React.createElement(InputAdornment, {
            position: "end"
          }, React.createElement(Icon, Object.assign({
            hoverable: true,
            type: "expression",
            onClick: this.openXPathEditor
          }, buttonProps)))
        }
      })), this.state.open && React.createElement(XPathDialog, {
        value: this.props.value,
        onChange: this.onChange,
        onClose: this.closeXPathEditor,
        isCondition: isCondition,
        workspace: workspace,
        path: path
      }));
    }
  }]);

  return XPath;
}(React.Component);

XPath.defaultProps = {
  value: '',
  isCondition: false,
  buttonProps: {}
};
export default XPath;